import type { AudienceDto } from "@intelligems/ig-types/dtos/audiences";
import isEqual from "lodash.isequal";

// Normalize an audience so only "who matches" fields are compared.
// Strips IDs (audience-level and filter-level) and routing/analytics fields
// (action, variationId, elseVariationId, excludeFromAnalytics,
// elseExcludeFromAnalytics) that describe what happens to matched users rather
// than who gets matched. Visitor split / traffic percentage is not a separate
// field on audiences, so it's naturally excluded.
const normalizeAudience = (audience: AudienceDto) => {
  const {
    id: _id,
    experienceId: _expId,
    elseVariationId: _elseVarId,
    elseExcludeFromAnalytics: _elseAnalytics,
    ...rest
  } = audience;
  return {
    ...rest,
    filters: (rest.filters ?? []).map((filter) => {
      const {
        id: _fId,
        action: _action,
        variationId: _vId,
        excludeFromAnalytics: _analytics,
        ...filterRest
      } = filter;
      return filterRest;
    }),
  };
};

export const audiencesAreEquivalent = (
  a: AudienceDto | null | undefined,
  b: AudienceDto | null | undefined
): boolean => {
  if (!a || !b) {
    return !a && !b;
  }
  return isEqual(normalizeAudience(a), normalizeAudience(b));
};
